import {useContext} from 'react';
import {SettingsContext} from "store/Settings";

function useSettings() {
    return useContext(SettingsContext);
}

export default useSettings;
